// This is how a normal module looks like. You can copy paste this
// for any new module you want to create. Then you can import it in
// main.js and call "init()" to execute the code.


const Slider = ((($) => {
  let slider;
  let options;
  let slider_img;
  function init() {
    slider = $('.js-slider');
    options = {
      dots: true,
      infinite: true,
      speed: 1000,
      autoplay: false,
      autoplaySpeed: 5000,
      slidesToShow: 1,
      slidesToScroll: 1,
      adaptiveHeight: true,
      arrows: true,
      asNavFor: '.js-slider-img',
      prevArrow: $('.arrow_left'),
      nextArrow: $('.arrow_right')
    };
    slider.slick(options);

    slider_img = $('.js-slider-img');
    options = {
      dots: false,
      infinite: true,
      speed: 1000,
      fade: true,
      autoplay: false,
      autoplaySpeed: 5000,
      slidesToShow: 1,
      slidesToScroll: 1,
      asNavFor: '.js-slider',
      arrows: false,
    };
    slider_img.slick(options);

    $('.js-slider-hero').slick({
      dots: false,
      infinite: true,
      arrows: false,
      speed: 1000,
      autoplay: true,
      autoplaySpeed: 5000,
      slidesToShow: 1,
      slidesToScroll: 1,
      centerMode: true,
      focusOnSelect: true
    });

    if($(window).width() < 992) {
      $('.icons-set > .row').slick({
        dots: true,
        infinite: true,
        arrows: false,
        speed: 1000,
        autoplay: true,
        autoplaySpeed: 5000,
        slidesToShow: 1,
        slidesToScroll: 1,
      });

      $('.Localization_images').slick({
        dots: false,
        infinite: true,
        arrows: false,
        speed: 1000,
        autoplay: true,
        autoplaySpeed: 5000,
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
        focusOnSelect: true
      });
    }

    slider.on('afterChange', function(event, slick, currentSlide) {
      $(this);
      if(currentSlide == 0) {
        $('.concept_slider_line_item').css('left', '0%');
      }
      if(currentSlide == 1) {
        $('.concept_slider_line_item').css('left', '25%');
      }
      if(currentSlide == 2) {
        $('.concept_slider_line_item').css('left', '50%');
      }
      if(currentSlide == 3) {
        $('.concept_slider_line_item').css('left', '75%');
      }
    });

    $('.arrow_left').click(function() {
      $(this);
      slider.slick('slickPrev');
    });

    $('.arrow_right').click(function() {
      $(this);
      slider.slick('slickNext');
    });

    // function applyHiddenClass() {
    //   $.each($('.slick-slide'), function() {
    //     if ($(this).attr('aria-hidden') == 'true') {
    //       $(this).find('.img').addClass('hidden');
    //     }
    //     else {
    //       $(this).find('.img').removeClass('hidden');
    //     }
    //   });
    // }
    //
    // slider.on('afterChange', function(event, slick, currentSlide) {
    //   $(this);
    //   nextSlide = currentSlide;
    //   if (nextSlide !== currSlide) {
    //     $('.slick-active .img').removeClass('animated fadeIn');
    //     $('.slick-active .img').addClass('hidden');
    //   }
    // });
    //
    // slider.on('setPosition', function(event, slick, currentSlide) {
    //   $(this);
    //
    //   if (nextSlide !== currSlide) {
    //     $('.slick-active .img').removeClass('hidden');
    //     $('.slick-active .img').addClass('animated fadeIn');
    //   }
    //   applyHiddenClass();
    //   currentSlide;
    // });
    //
    // slider.on('beforeChange', function(event, slick, currentSlide) {
    //   $(this);
    //   currSlide = currentSlide;
    //   $('.slick-active .img').addClass('hidden');
    // });
  }
  return {
    init,
  };
}))(jQuery);

export default Slider;


// WEBPACK FOOTER //
// ./src/static/js/modules/carousel-slider.js